import { observer } from 'mobx-react-lite';
import { getDensityModeString } from 'owa-session-store';
import * as React from 'react';
import { isReadingPanePositionOff } from 'owa-mail-layout';

const styles = require('./MailListGroupHeader.scss');
const classNames = require('classnames/bind').bind(styles);
export interface MailListGroupHeaderProps {
    headerText: string;
    groupHeaderStylesAsPerUserSettings: string;
}

const MailListGroupHeader = observer(function MailListGroupHeader(props: MailListGroupHeaderProps) {
    const { headerText, groupHeaderStylesAsPerUserSettings } = props;

    const headerClassNames = classNames(
        getDensityModeString(),
        styles.outerContainer,
        groupHeaderStylesAsPerUserSettings,
        styles.alignToMailListPersonaPadding,
        isReadingPanePositionOff()
            ? '$singleLineCirclePersonaDivWidth'
            : 'threeColumnCirclePersonaDivWidth'
    );

    return <div className={headerClassNames}>{headerText}</div>;
});
export default MailListGroupHeader;
